import { Reveal } from "./Reveal";

const LOGOS = [
  { src: "/logos/tedx.png", alt: "TEDx" },
  { src: "/logos/shrm.png", alt: "SHRM — Society for Human Resource Management" },
  { src: "/logos/atd.png", alt: "ATD — Association for Talent Development" },
  { src: "/logos/hrci.png", alt: "HRCI" },
  { src: "/logos/npr.png", alt: "NPR" },
  { src: "/logos/cnn.png", alt: "CNN" },
];

export const TrustBar = () => (
  <section className="border-b border-navy/10 bg-cream py-14" data-testid="trust-bar">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-navy/50">
          Catherine Mattice &amp; Civility Partners — featured and trusted by
        </p>
        <div className="mt-8 flex flex-wrap items-center gap-4" data-testid="trust-bar-logos">
          {LOGOS.map((logo) => (
            <div
              key={logo.alt}
              className="flex h-16 w-32 items-center justify-center rounded-xl border border-navy/10 bg-white px-4 py-2 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-0.5 hover:border-terra/40 hover:shadow-md sm:w-36"
            >
              <img src={logo.src} alt={logo.alt} className="max-h-11 w-auto object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
